import * as yup from 'yup'
import i18n, { translate as t } from '../../i18n'

export const profileSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t<string>('general.validator.empty'))
    .min(3, () => i18n.t('general.validator.minCharacter', { number: 3 })),
  birthday: yup
    .date()
    .required(() => t('general.validator.empty')),
  gender: yup
    .string()
    .required(() => t('general.validator.empty')),
  email: yup
    .string()
    .required(() => t('general.validator.empty'))
    .email(() => t('general.validator.invalidEmail')),
  whatsapp: yup
    .string()
})
